module.exports = __webpack_public_path__ + "img/qc_watch1.687c2440.png";